import React, { lazy } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyload<T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(importFn)
}
